import React from 'react';
import {
    IReportsTableFilteringValues,
    ReportsTableFilteringContext,
} from '../../contexts/reportsTable/reportsTableFilteringContext.legacy';

export function useLegacyReportsTableFiltering(): IReportsTableFilteringValues {
    const context = React.useContext(ReportsTableFilteringContext);
    if (!context) {
        throw new Error('useLegacyReportsTableFiltering must be wrapped in a ReportsTableFilteringContextProvider');
    }
    return context;
}
